"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.averageLineSerieForCategories = function (props) {
    var values = props.values, name = props.name, color = props.color, dashStyle = props.dashStyle;
    var processedAverageSerie = [];
    var additionalSideSpace = 0.31;
    values.forEach(function (value, index) {
        processedAverageSerie.push([index - additionalSideSpace, value], [index + additionalSideSpace, value]);
        //Add null to create gab between the categories
        processedAverageSerie.push(null);
    });
    return {
        name: name !== null && name !== void 0 ? name : 'Average',
        type: 'line',
        data: processedAverageSerie,
        color: color,
        dashStyle: dashStyle !== null && dashStyle !== void 0 ? dashStyle : 'Dash',
        marker: {
            enabled: false,
        },
        tooltip: {},
    };
};
exports.default = exports.averageLineSerieForCategories;
//# sourceMappingURL=average-graph-line.js.map